export default "__VITE_ASSET__3NOJ1cbp__"